import { changeLanguage } from 'i18next';
import { Tenant } from '@components/dashboard/sysadmin/sysadmin-tenant/types/tenant.types';

interface TenantActivationDependencies {
  setActiveTenant: (tenant: Tenant) => void;
  setBrandingColors: (colors: { primary: string; secondary: string }) => void;
}

export const activateTenant = (
  tenant: Tenant,
  { setActiveTenant, setBrandingColors }: TenantActivationDependencies
) => {
  // Set active tenant
  setActiveTenant(tenant);

  // Change language
  changeLanguage(tenant.defaultLanguage ?? 'en');

  // Update branding colors if available
  if (tenant.brandingColors) {
    setBrandingColors({
      primary: tenant.brandingColors.primary,
      secondary: tenant.brandingColors.secondary,
    });
  }
};
